import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import * as yup from "yup";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import { connect } from "react-redux";
import "../../Sass/Common.scss";
import { START_UPDATE_REPEAT_ORDER_DATE } from "../../Actions/RepeatOrderAction";

const useStyle = makeStyles((theme) => ({}));

const PatientOrderAndMediDialog = (props) => {
  const {
    open,
    setOpen,
    patientDetailsId,
    updateRepeatOrderDateAction,
    updateRepeatOrderDates,
    setStatusApi,
    setPatientStatus,
  } = props;
  const classes = useStyle();
  const [dateDate, setDateData] = useState({
    id: "",
    order_date: "",
    medication_date: "",
  });

  /** Order Date Validation Schema */
  let orderDateSchema = {
    order_date: yup
      .string()
      .nullable()
      .required("The next order date field is required."),
  };

  /** Condtion Based on schema Set */
  let schema = { ...orderDateSchema };
  /** Condtion Based on schema Set */
  const repeatOrderDateSchema = yup.object().shape({ ...schema });

  /** Handle Update Date Funcation */
  const handleUpdateDate = (formValues) => {
    if (formValues?.order_date !== "") {
      setStatusApi(true);
    }
    const payloadOrderDate = {
      id: patientDetailsId.order[0],
      order_date: moment(new Date(formValues?.order_date)).format("YYYY-MM-DD"),
    };
    if (formValues.medication_date) {
      payloadOrderDate.medication_date = moment(
        new Date(formValues?.medication_date)
      ).format("YYYY-MM-DD");
    } else {
      payloadOrderDate.medication_date = "";
    }
    updateRepeatOrderDateAction(
      payloadOrderDate,
      patientDetailsId.id,
      "Active",
      "repeatorder"
    );
    handleClose();
  };

  const { guardedSubmit: xssGuardedPatientOrderMedi } = useXssGuard(handleUpdateDate);


  const {
    handleSubmit,
    values,
    errors,
    touched,
    resetForm,
    setErrors,
    setFieldValue,
    handleBlur,

} = useFormik({
    initialValues: { ...dateDate },
    validationSchema: repeatOrderDateSchema,
    onSubmit: xssGuardedPatientOrderMedi,
  });

  const handleClose = () => {
    setOpen(false);
    setDateData({
      id: "",
      order_date: "",
      medication_date: "",
    });
    resetForm();
    setPatientStatus("");
  };

  useEffect(() => {
    const errors = updateRepeatOrderDates?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [updateRepeatOrderDates?.error]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={() => handleClose()}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.rsUpdateDialog}
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          title={`Schedule next order for ${patientDetailsId?.name} ${
            patientDetailsId?.last_name ? patientDetailsId?.last_name : ""
          }${patientDetailsId?.dob ? "," : ""} ${
            patientDetailsId?.dob
              ? moment(new Date(patientDetailsId?.dob)).format("DD-MM-YYYY")
              : ""
          }`}
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogContent>
            <Grid container columnSpacing={2.5} rowSpacing={3}>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Next Order Date *"
                    views={["year", "month", "day"]}
                    value={values?.order_date}
                    onChange={(newDate) => {
                      setFieldValue("order_date", newDate);
                    }}
                    inputFormat="DD-MM-YYYY"
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        size="small"
                        name="order_date"
                        {...params}
                        error={touched?.order_date && errors?.order_date}
                        helperText={touched?.order_date && errors?.order_date}
                        onBlur={handleBlur}
                      />
                    )}
                    name="order_date"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disablePast
                    label="Next Medication Starting Date (optional)"
                    views={["year", "month", "day"]}
                    value={values?.medication_date}
                    onChange={(newDate) => {
                      setFieldValue("medication_date", newDate);
                    }}
                    inputFormat="DD-MM-YYYY"
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        size="small"
                        name="medication_date"
                        {...params}
                        error={
                          touched?.medication_date && errors?.medication_date
                        }
                        helperText={
                          touched?.medication_date && errors?.medication_date
                        }
                        onBlur={handleBlur}
                      />
                    )}
                    name="medication_date"
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" type="submit">
              Submit
            </Button>
            <Button variant="outlined" onClick={() => handleClose()}>
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
const mapStateToProps = (state) => ({
  updateRepeatOrderDates: state.order.updateRepeatOrderDates,
});
const mapDispatchToProps = (dispatch) => ({
  updateRepeatOrderDateAction: (payload, id, status, actiontype) =>
    dispatch({
      type: START_UPDATE_REPEAT_ORDER_DATE,
      payload,
      id,
      status,
      actiontype,
    }),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientOrderAndMediDialog);
